import React, { Component } from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import { withStyles } from "@material-ui/styles";

import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";

import colors from "../../assets/style/colors";

import images from "../../assets/img/images";

const theme = {
  container: {
    position: "relative",
  },
  input: {
    maxWidth: "100%",
    //height: "29px",
    fontSize: "1em",
  },
  inputFocused: {
    outlined: "none",
  },
  suggestionsContainer: {
    display: "none",
  },
  suggestionsContainerOpen: {
    display: "block",
    position: "absolute",
    top: "29px",
    width: "100%",
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    backgroundColor: colors.white,
    borderRadius: "3px",
    zIndex: "2",
    fontWeight: "normal",
    color: colors.black54,
    fontSize: "1em",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
    textAlign: "left",
  },
  suggestion: {
    cursor: "pointer",
    padding: "5px",
  },
  suggestionHighlighted: {
    backgroundColor: colors.lightGreenBg,
  },
};

const styles = {
  endAdornment: {
    padding: "5px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  selectValue: {
    padding: "5px",
    paddingRight: "0px",
  },
  selectFilter: {
    width: "100%",
    margin: 0,
    fontWeight: "normal",
    textAlign: "left",
  },
  inputDefault: {
    height: "36px",
  },
};

class SmartSearchRef extends Component {
  mounted = false;

  constructor(props) {
    super(props);
    this.state = {
      inputValue: props.activeFilter || "",
      suggestions: [],
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getSuggestions = (value) => {
    var inputValue = value.trim().toLowerCase();
    if (inputValue.length < 3) {
      return [];
    } else {
      var suggestions = this.props.data.filter(
        (row) =>
          this.getSuggestionValue(row) &&
          this.getSuggestionValue(row).toLowerCase().includes(inputValue)
        //.slice(0, inputValue.length) === inputValue
      );
      var uniqueValues = [];
      var uniqueSuggestions = [];
      suggestions.forEach((sug) => {
        if (!uniqueValues.includes(this.getSuggestionValue(sug))) {
          uniqueValues.push(this.getSuggestionValue(sug));
          uniqueSuggestions.push(sug);
        }
      });
      return uniqueSuggestions;
    }
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onSuggestionSelected = (event, { suggestionValue }) => {
    this.props.onSelect(suggestionValue, this.props.filter);
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (this.state.suggestions.length === 0) {
        this.props.onSelect(this.state.inputValue, this.props.filter);
      }
    }
  };

  handleChange = (event, { newValue }) => {
    this.setState({
      inputValue: newValue,
    });
  };

  handleClear = () => {
    this.setState({
      inputValue: "",
    });
    this.props.onSelect("", this.props.filter);
  };

  getSuggestionValue = (suggestion) => {
    let value = suggestion;
    this.props.filter.forEach((level) => {
      value = value[level];
    });
    if (value) {
      return value.toString();
    }
    return value;
  };

  renderSuggestion = (suggestion) => {
    return <div>{this.getSuggestionValue(suggestion)}</div>;
  };

  renderInputComponent = (inputProps) => {
    return (
      <TextField
        variant="outlined"
        {...inputProps}
        InputProps={{
          className: this.props.inputClass || this.props.classes.inputDefault,
          inputProps: {
            className: this.props.classes.selectValue,
          },
          endAdornment:
            this.state.inputValue.length > 0 ? (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={this.handleClear}
                  style={{ opacity: "0.54" }}
                  classes={{ root: this.props.classes.endAdornment }}
                >
                  <img
                    src={images.closeIcon}
                    alt="search"
                    width="12px"
                    height="12px"
                  />
                </IconButton>
              </InputAdornment>
            ) : (
              <></>
            ),
        }}
        margin="dense"
        className={this.props.classes.selectFilter}
      />
    );
  };

  render() {
    let myTheme = theme;
    if (this.props.specificHeight) {
      myTheme.suggestionsContainerOpen.top = this.props.specificHeight;
    }

    return (
      <Autosuggest
        theme={myTheme}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={{
          value: this.state.inputValue,
          onChange: this.handleChange,
          onKeyPress: this.handleKeyPress,
        }}
        renderInputComponent={this.renderInputComponent}
      />
    );
  }
}

SmartSearchRef.propTypes = {
  filter: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default withStyles(styles)(SmartSearchRef);
